import fifthaveClient from './fifthaveClient'

function getUserInfoDetail(userId) {
    return fifthaveClient.get(`/api/v1/_internal/users/${userId}`);
}

export {
    getUserInfoDetail
}
